import React from "react";
import ApplicationForm from "../components/ApplicationForm";
import { connect } from "react-redux";
import ErrorBoundary from "../components/ErrorBoundary";
import { db } from "../config";

class Application extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      hasApplied: false
    };
  }

  componentWillMount() {
    const { user, history, location } = this.props;
    const userVerified = user && user.emailVerified;
    // only verified users can apply
    if (!userVerified) {
      history.replace("/login", { from: location.pathname });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const { user, history, location } = this.props;
    if (!user) {
      history.push("/login", { from: location.pathname });
    }

    this.hasApplied().then(res => {
      this.setState({ hasApplied: !!res });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ user: nextProps.user });
    if (!nextProps.user) {
      this.props.history.push("/login", { from: this.props.location.pathname });
    }
  }

  hasApplied() {
    const jobId = this.props.match.params.id;
    const email = (this.state.user && this.state.user.email) || "";
    return checkApplied(jobId, email);
  }

  render() {
    const { user, hasApplied } = this.state;
    const [firstName, lastName] = user ? user.displayName.split(" ") : [];
    return (
      <ErrorBoundary>
        <div className="mt4 mb5 center" style={{ maxWidth: 1000 }}>
          <h1 className="f3 mb3 tc">
            {this.props.jobTitle || ""} Application Form
          </h1>
          {hasApplied ? (
            <p className="red tc">You already applied for this job</p>
          ) : null}

          <ApplicationForm
            firstName={firstName}
            lastName={lastName}
            email={(user && user.email) || ""}
            phoneNumber={(user && user.phoneNumber) || ""}
            hasApplied={hasApplied}
          />
        </div>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const jobTitle = state.vacancies.filter(job => job.id === id)[0].title;
  return {
    user: state.user,
    jobTitle
  };
};

export default connect(mapStateToProps)(Application);

const checkApplied = function(jobId, email) {
  // check if user has applied before
  return db
    .collection(jobId)
    .where("email", "==", email)
    .get()
    .then(docs => {
      let temp;
      docs.forEach(doc => {
        temp = doc.data();
      });
      return temp;
    });
};



// WEBPACK FOOTER //
// ./src/pages/apply.js